export const WTAI_EXPRESS_URL = '/express/api/v1'

// PUSHER CHANNEL EVENTS
export const CHANNEL_CONNECTED_EVENT = 'pusher:subscription_succeeded'
export const CHANNEL_SUBSCRIPTION_ERROR_EVENT = 'pusher:subscription_error'
export const CHANNEL_PROOFREAD_FULL_ANALYZE_EVENT = 'proofread:analyze_full'
export const CHANNEL_PROOFREAD_SYNONYM_SELECTION_ANALYZE_EVENT =
  'proofread:analyze_synonym_selection'
export const CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_ANALYZE_EVENT =
  'proofread:analyze_paraphrase_selection'
export const CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_SHORTEN_ANALYZE_EVENT =
  'proofread:analyze_paraphrase_selection_shorten'
export const CHANNEL_PROOFREAD_PARAPHRASE_SELECTION_EXPAND_ANALYZE_EVENT =
  'proofread:analyze_paraphrase_selection_expand'
export const CHANNEL_PROOFREAD_PARAPHRASE_ANALYZE_EVENT = 'proofread:analyze_paraphrase'
export const CHANNEL_PROOFREAD_GRAMMAR_ANALYZE_EVENT = 'proofread:analyze_grammar'
export const CHANNEL_PROOFREAD_CLARITY_FEEDBACK_REASON_ANALYZE_EVENT =
  'proofread:analyze_clarity_reason'

// PUSHER GLOBAL EVENTS
export const PUSHER_STATE_CHANGE_EVENT = 'state_change'
export const PUSHER_CONNECTED_EVENT = 'connected'
export const PUSHER_STATE_DISCONNECTED = 'disconnected'
export const PUSHER_STATE_UNAVAILABLE = 'unavailable'
export const PUSHER_STATE_CONNECTING = 'connecting'
export const PUSHER_ERROR_EVENT = 'error'

export type PUSHER_STATES =
  | typeof PUSHER_STATE_DISCONNECTED
  | typeof PUSHER_STATE_UNAVAILABLE
  | typeof PUSHER_STATE_CONNECTING
  | typeof PUSHER_CONNECTED_EVENT
